// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ src, alt, ...other }) {
  const { user } = useAuth();

  // Prefer any real image we have. Linguists store theirs as `image`; staff
  // use `avatarUrl`/`photoURL`. If the image fails to load, MUI Avatar falls
  // back to the initials placeholder below.
  const imageSrc =
    src || user?.avatarUrl || user?.image || user?.photoURL || undefined;

  // A reliable display name for the initials placeholder. Linguists usually
  // have firstName/lastName rather than `name`, so fall back through those.
  const displayName =
    user?.name ||
    user?.displayName ||
    [user?.firstName, user?.lastName].filter(Boolean).join(' ') ||
    user?.email ||
    'User';

  const { name: initial, color } = createAvatar(displayName);

  return (
    <Avatar
      src={imageSrc}
      alt={alt || displayName}
      color={imageSrc ? 'default' : color}
      {...other}
    >
      {initial}
    </Avatar>
  );
}
